<template>
    <div>
        {{ property.street }}<br />{{ property.city }}, {{ property.state }} {{ property.zip }}
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsProperty',
    props: {
        property: VueTypes.shape({
            street: VueTypes.string.isRequired,
            state: VueTypes.string.isRequired,
            city: VueTypes.string.isRequired,
            zip: VueTypes.string.isRequired,
        }).isRequired.loose,
    },
};
</script>
